<template>
  <Base icon="mdi-bank" :satisfied="requirement.satisfied" tooltip>
    <span>
      {{ requirement.institution.name }}
    </span>
    <span slot="tooltip">
      {{ first ? 'The ideal candidate' : 'and' }}
      {{ requirement.mandatory ? 'must' : 'could' }}
      {{ requirement.negative ? 'not' : '' }} a qualification issued by
      {{ requirement.institution.name }}
    </span>
  </Base>
</template>

<script>
// Component
import Base from '@/components/guest/opportunities/requirements/Base'

// Vue Component
export default {
  components: { Base },
  props: {
    requirement: { type: Object, required: true },
    first: { type: Boolean },
  },
}
</script>
